export default function More({ color = "black" }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1571_1688)">
        <path
          d="M12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0ZM12.5 22.5C6.701 22.5 2 17.799 2 12C2 6.201 6.701 1.5 12.5 1.5C18.299 1.5 23 6.201 23 12C23 17.799 18.299 22.5 12.5 22.5Z"
          fill={color}
        />
        <path
          d="M12.5 13.5C13.3284 13.5 14 12.8284 14 12C14 11.1716 13.3284 10.5 12.5 10.5C11.6716 10.5 11 11.1716 11 12C11 12.8284 11.6716 13.5 12.5 13.5Z"
          fill={color}
        />
        <path
          d="M17.75 13.5C18.5784 13.5 19.25 12.8284 19.25 12C19.25 11.1716 18.5784 10.5 17.75 10.5C16.9216 10.5 16.25 11.1716 16.25 12C16.25 12.8284 16.9216 13.5 17.75 13.5Z"
          fill={color}
        />
        <path
          d="M7.25 13.5C8.07843 13.5 8.75 12.8284 8.75 12C8.75 11.1716 8.07843 10.5 7.25 10.5C6.42157 10.5 5.75 11.1716 5.75 12C5.75 12.8284 6.42157 13.5 7.25 13.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1571_1688">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
